import './update-basket';
import './open-basket-fly';
import './clear-basket-fly';
import './quantity-basket-fly';
import './delete-basket-fly';
import './delay-basket-fly';
import './one-click-buy';
